import type { ReactNode } from "react";
import { useRef } from "react";
import { styled } from "styled-components";

import { useScrollGroupItem } from "../ScrollGroup";
import { useStickyGrid } from "./context";

export function StickyGridBody({ children }: { children: ReactNode }) {
  const { templateColumns, gap } = useStickyGrid();

  const contentRef = useRef<HTMLDivElement>(null);
  useScrollGroupItem({ refObject: contentRef });

  return (
    <StyledStickyContent
      ref={contentRef}
      $templateColumns={templateColumns}
      $gap={gap}
    >
      {children}
    </StyledStickyContent>
  );
}

const StyledStickyContent = styled.div<{
  $templateColumns: string;
  $gap?: string;
}>`
  display: grid;
  gap: ${({ $gap }) => $gap ?? 0};
  grid-template-columns: ${({ $templateColumns }) => $templateColumns};
  width: 100%;

  overflow: auto;
  overscroll-behavior-x: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
